import CombinedProvider from "./src/states/combinedProvider"

export const wrapRootElement = CombinedProvider
